export const REPORT_COMMENT_MUTATION = `
  mutation ReportCommentMutation(
    $commentId: ID!
    $reportReason: CommentReportReason!
  ) {
    me {
      reportComment(commentId: $commentId, reportReason: $reportReason) {
        id
        status
        commentReportReason
      }
    }
  }
`;
